/* eslint-disable react/require-optimization */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import TextInput from "./TextInput";
import WizardFooter from "./WizardFooter";
export const fields = ["ssn", "phone", "job_description", "starting_pay"];

const validate = (values, props) => {
  const errors = {};
  ["ssn", "phone", "job_description"].forEach(field => {
    if (!values[field]) {
      errors[field] = props.allText.shared.required;
    }
  });

  const ssnRegex = /^\d\d\d[- ]?\d\d[- ]?\d\d\d\d$/;
  const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

  if (!values.ssn) {
    errors.ssn = props.allText.shared.required;
  } else if (!ssnRegex.test(values.ssn)) {
    errors.ssn = props.allText.shared.invalid_ss_number;
  }
  if (!values.phone) {
    errors.phone = props.allText.shared.required;
  } else if (!phoneRegex.test(values.phone)) {
    errors.phone = props.allText.shared.invalid_tel_number;
  }
  return errors;
};
export class WizardFormEmployeeInfo01 extends Component {
  render() {
    const normalizePhone = value => {
      if (!value) return value;

      const digits = value.replace(/\D/g, "").slice(0, 10);

      const area = digits.slice(0, 3);
      const prefix = digits.slice(3, 6);
      const line = digits.slice(6, 10);

      if (digits.length <= 3) return `(${area}`;
      if (digits.length <= 6) return `(${area}) ${prefix}`;
      return `(${area}) ${prefix}-${line}`;
    };

    const {
      allText,
      fields: { ssn, phone, job_description, starting_pay },
      handleSubmit,
      previousPage,
    } = this.props;
    const text = { ...allText.shared, ...allText.info01 };
    const progress = 0;
    return (
      <form onSubmit={handleSubmit} className="form-horizontal">
        <div className="wizard-page-content employee-info">
          <div className="page-title-container">
            <span className="page-title">{text.title}</span>
            <span className="wizard-text">{text.subtitle}</span>
          </div>

          <div className="row last-question-margin">
            <div className="col-12 col-sm-6 col-md-4 phone-container">
              <div className="wizard-text">{text.phone}</div>
              <TextInput
                text={text}
                field={{
                  ...phone,
                  onChange: e => {
                    const rawValue = e.target.value;
                    const formatted = normalizePhone(rawValue);
                    phone.onChange(formatted);
                  },
                }}
                placeholder={text.phone}
              />
            </div>
            <div className="col-12 col-sm-6 col-md-4 ssn-container">
              <div className="wizard-text">{text.ssn}</div>
              <TextInput text={text} field={ssn} placeholder={text.ssn} />
            </div>

            <div className="clearfix visible-md-block visible-lg-block" />

            <div className="col-12 col-sm-12 col-md-8 bigger">
              <div className="wizard-text">{text.job_description}</div>
              <TextInput
                text={text}
                field={job_description}
                placeholder={text.job_description}
              />
            </div>

            <div className="clearfix visible-md-block visible-lg-block" />
            <div className="col-12 col-sm-12 col-md-8 phone-container">
              <div className="wizard-text">{text.starting_pay}</div>
              <TextInput
                text={text}
                field={starting_pay}
                placeholder={text.starting_pay_holder}
              />
            </div>
            <div className="clearfix visible-md-block visible-lg-block" />
          </div>
        </div>
        <WizardFooter
          text={text}
          previousPage={previousPage}
          progress={progress}
        />
      </form>
    );
  }
}

WizardFormEmployeeInfo01.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormEmployeeInfo01);



// WEBPACK FOOTER //
// ./src/components/WizardFormEmployeeInfo01.js